import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Heart, Loader2, ArrowLeft } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import { Helmet } from "react-helmet-async";

export default function CustomerWishlist() {
    const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        api.get("/me/wishlist")
            .then((r) => setItems(r.data || []))
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        load();
    }, []);

    if (!user || user.role !== "customer") {
        return (
            <div className="container-edge py-16 text-center">
                <p className="font-mono text-ink/60">Inicie sessão para ver a sua wishlist.</p>
                <Link to="/conta/login" className="btn-primary inline-flex mt-4">Entrar</Link>
            </div>
        );
    }

    return (
        <div className="container-edge py-10" data-testid="customer-wishlist">
            <Helmet><title>A minha wishlist | SOSTONERS</title></Helmet>
            <Link to="/conta" className="inline-flex items-center gap-2 text-sm font-mono text-ink/60 hover:text-magenta mb-4">
                <ArrowLeft size={14} /> Voltar à conta
            </Link>
            <div className="flex items-center gap-3 mb-8">
                <div className="border-2 border-ink p-2 bg-magenta">
                    <Heart size={20} className="text-white" fill="white" />
                </div>
                <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter">A minha wishlist</h1>
                <span className="font-mono text-sm text-ink/50">· {items.length}</span>
            </div>

            {loading ? (
                <Loader2 className="animate-spin" size={20} />
            ) : items.length === 0 ? (
                <div className="text-center py-16 border-2 border-dashed border-ink/30">
                    <Heart size={32} className="mx-auto mb-3 text-ink/30" />
                    <p className="font-mono text-ink/60 mb-4">A sua wishlist está vazia.</p>
                    <Link to="/loja" className="btn-secondary inline-flex">Explorar produtos</Link>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                    {items.map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
            )}
        </div>
    );
}
